export default "__VITE_ASSET__CZc8sl08__"